import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PATH, GRAB_WEB_ORIGIN_URL } from "@configs";

export const GrabMappingPage: React.FC = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  window.addEventListener("message", function (event) {
    if (event.origin === GRAB_WEB_ORIGIN_URL) {
      const message = event.data;
      if (message === "MAPPING_SUCCESSFUL") {
        navigate(PATH.MAPPING_SUCCESS);
      }

      if (message === "MAPPING_FAILED") {
        navigate(PATH.MAPPING_FAIL);
      }

      if (message === "MAPPING_ALREADY_MAPPED") {
        navigate(PATH.MAPPING_ALREADY_MAPPING);
      }
    }
  });

  return (
    <>
      <iframe
        src={`${GRAB_WEB_ORIGIN_URL}/mex-auth/form?lang=${i18n.language}`}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: "100%",
          height: "100%",
        }}></iframe>
    </>
  );
};
